import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ConsignmentRatingType from "../../enums/ConsignmentRatingType";
import WouldRecommendType from "../../enums/WouldRecommendType";
import { Rate, Spin } from "antd";
import { DateTimeFormat } from "../../components/FormattersTS";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { axiosErrorHandler } from "../../../../swzutils";
import ConsignmentStatusType from "../../enums/ConsignmentStatusType";
const ConsignmentRatingsPanel = ({ consignment }) => {
    const [stateRatings, setStateRatings] = useState([]);
    const [stateRatingsLoading, setStateRatingsLoading] = useState(false);
    useEffect(() => {
        if (consignment?.id) {
            if (ConsignmentStatusType.COMPLETED === ConsignmentStatusType.valueOf(consignment?.status)) {
                loadRatings();
            }
        }
    }, [consignment?.id]);
    const loadRatings = () => {
        setStateRatingsLoading(true);
        axios.get(`/admin/v1/consignments/${consignment.id}/ratings`)
            .then(response => {
            setStateRatings(response.data);
        })
            .catch(axiosErrorHandler)
            .finally(() => {
            setStateRatingsLoading(false);
        });
    };
    return (_jsx(Spin, { spinning: stateRatingsLoading, children: stateRatings && stateRatings.length ?
            stateRatings.map((rating, index) => {
                let ratingType = ConsignmentRatingType.fromString(rating.type);
                let wouldRecommendType = null;
                if ("wouldRecommend" in rating) {
                    wouldRecommendType = WouldRecommendType.valueOf(rating.wouldRecommend) ?? null;
                }
                return (_jsxs("div", { children: [_jsx("h2", { children: ratingType?.description }), _jsxs("div", { className: "text-center", style: { paddingBottom: '10px' }, children: [_jsx(Rate, { allowHalf: true, value: rating.starRating, disabled: true, className: "large-rating" }), _jsx("span", { style: { paddingLeft: '10px' }, children: rating.starRating })] }), _jsxs("dl", { children: [_jsx("dt", { children: "Created At" }), _jsx("dd", { children: _jsx(DateTimeFormat, { value: rating.createdAt }) }), _jsx("dt", { children: "Comments" }), _jsx("dd", { children: rating.comments }), wouldRecommendType && _jsx("dt", { children: "Would Recommend?" }), wouldRecommendType && _jsx("dd", { children: wouldRecommendType.description })] }), _jsx("hr", {})] }, index));
            })
            : _jsx("p", { children: "\u2014" }) }));
};
export default ConsignmentRatingsPanel;
